import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackIntegrationsPageViewed.meta';

export const useTrackIntegrationsPageViewed = () => {
  const { track } = useAnalyticsUtilities();

  const trackIntegrationsPageViewed = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackIntegrationsPageViewed };
};
